import { useEffect } from "react";

/**
 * OAuth callback page — the URL Meta redirects to after the user authenticates.
 *
 * This page:
 *  1. Reads `code` and `state` (channel type) from the URL
 *  2. Sends them back to the opener window via postMessage
 *  3. Closes itself
 */
export default function FacebookOAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");
    const errorDescription = params.get("error_description");
    const state = params.get("state") || "facebook";

    const msg = error
      ? { type: "meta_oauth_error", error, error_description: errorDescription, state }
      : { type: "meta_oauth_code", code, state };

    if (window.opener) {
      try { window.opener.postMessage(msg, window.location.origin); } catch (e) { /* origin mismatch */ }
      setTimeout(() => window.close(), 400);
    }
  }, []);

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", flexDirection: "column", gap: 12, fontFamily: "system-ui",
      background: "linear-gradient(135deg, #047857, #064E3B)", color: "white"
    }}>
      <div style={{
        width: 50, height: 50, border: "4px solid rgba(255,255,255,0.3)",
        borderTop: "4px solid white", borderRadius: "50%",
        animation: "spin 1s linear infinite"
      }} />
      <p style={{ fontSize: 16, opacity: 0.9 }}>Finalizing connection...</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
